import { createAction } from "redux-starter-kit";
import { normalize } from "normalizr";

import { addEntities } from "../../entities";
import {
  UPDATE_LINEITEMS_CATEGORIES_FAILURE,
  UPDATE_LINEITEMS_CATEGORIES_REQUEST,
  UPDATE_LINEITEMS_CATEGORIES_SUCCESS
} from "../types";

export default lineItem => async (dispatch, getState, { api, schema }) => {
  try {
    dispatch(createAction(UPDATE_LINEITEMS_CATEGORIES_REQUEST)());
    const response = await api.finances.updateLineItemsCategories(lineItem);
    const data = normalize([response], [schema.lineItemCategory]);
    dispatch(addEntities(data.entities));
    dispatch(createAction(UPDATE_LINEITEMS_CATEGORIES_SUCCESS)());
  } catch (err) {
    dispatch(createAction(UPDATE_LINEITEMS_CATEGORIES_FAILURE)(err));
    throw err;
  }
};
